import React from 'react'
import { Box, Typography, Chip } from '@mui/material'
import { Mic, TrendingUp, MessageCircle } from 'lucide-react'
import { useGetEpisodePerformanceQuery } from 'graphql/generated/graphql'

function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export default function EpisodePerformance(): JSX.Element | null {
  const { data } = useGetEpisodePerformanceQuery()
  const episodes = data?.getEpisodePerformance ?? []

  // Only show episode-created signals (name starts with "EP:" or "Latest:")
  const episodeSignals = episodes.filter(
    (ep) => ep.topicName.startsWith('EP:') || ep.topicName.startsWith('Latest:')
  )

  if (episodeSignals.length === 0) return null

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <Mic size={16} color="#a855f7" />
        <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px', fontWeight: 600 }}>
          Episode Performance
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', pb: 1 }}>
        {episodeSignals.map((ep) => (
          <Box
            key={ep.topicId}
            sx={{
              minWidth: 200,
              p: 2,
              backgroundColor: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '12px',
              flexShrink: 0,
            }}
          >
            <Typography sx={{ color: 'white', fontWeight: 600, fontSize: '13px', mb: 0.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {ep.topicName.replace(/^(EP|Latest): ?/, '')}
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px', mb: 1 }}>
              {formatDate(ep.createdAt)}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <TrendingUp size={12} color="rgba(255,255,255,0.4)" />
                <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)' }}>
                  {String(ep.contentCount)} found
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <MessageCircle size={12} color="#a855f7" />
                <Typography sx={{ fontSize: '12px', color: '#a855f7', fontWeight: 600 }}>
                  {String(ep.engagementCount)} engaged
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
